import { useCallback } from "react";
const useLogOut = (authImplementation, setAuthProviderState) => {
  return useCallback(
    async (options) => {
      const logoutOutput = await authImplementation.logout(options);
      setAuthProviderState({
        userMetadata: null,
        currentUser: null,
        isAuthenticated: false,
        hasError: false,
        error: void 0,
        loading: false
      });
      return logoutOutput;
    },
    [authImplementation, setAuthProviderState]
  );
};
export {
  useLogOut
};
